module.exports = __webpack_public_path__ + "img/46800.02057145.jpg";